import { connect } from 'react-redux';
import View from './PlanImpactView';
import { planImpactLoadingSelector } from '../WhatIfsSelector';
import { isNumeric, createCustomPropType } from '../../../js/app/react/validators';

const mapStateToProps = (state, ownProps) => ({
  planImpactLoading: planImpactLoadingSelector(state, ownProps),
});

const PlanImpactContainer = connect(mapStateToProps)(View);

PlanImpactContainer.propTypes = {
  clientId: createCustomPropType(isNumeric).isRequired,
};

export default PlanImpactContainer;
